import React from 'react';
import {Route, Switch} from 'react-router-dom';

import App from './App';

export default (
    <Switch>
        <Route component={App} path='/'/>
          </Switch>
);



// WEBPACK FOOTER //
// ./src/routes.js